define('app/config/reportTypes',[],function() {
	'use strict';

	return {
		REPRT: 'REPORT',
		METRIC: 'METRIC',
		SEGMENT: 'SEGMENT',
		ALERT: 'ALERT'
	};
});

